export const CategoryKey = {
  restaurant: 'restaurant',
  bundle: 'bundle',
  sale: 'sale',
  new: 'new',
  trending: 'trending'
};

/**
 * 弹框进度条bar type key的集合
 * type: 进度条业务类型
 *
 * 进度条type包含在次集合中的，展示点击弹框bar
 */
export const PopupProgressBarKeys = ['trade_in_upsell'];
